import React from "react";
import ProductTypeListView from "domains/productType/components/ProductTypeListView";

const ProductTypeListPage: React.FC = () => {
  return <ProductTypeListView />;
};

export default ProductTypeListPage;
